import React from "react";
import { useState } from "react";
import api from "../api";
import { states } from "../data/selectData";
import BtnTailwind from "./BtnTailwind";
import PartnerCard from "./PartnerCard";
import SearchForm from "./SearchForm";
import SelectTailwind from "./SelectTailwind";

export default function Card({ getItems }) {
  // const [data, setData] = useState();
  // function getItems() {
  //   api.get("/api/form/subscription").then((res) => {
  //     console.log(res);
  //     setData(res.data);
  //   });
  // }

  return (
    <div className="mb-5">
      <div className="p-8 bg-white  rounded-lg shadow max-w-3xl m-auto">
        <p className="text-center text-3xl font-bold text-gray-800 ">
          Encontre um instalador
        </p>
        <p className="text-center mb-12 text-xl font-normal text-gray-500 "></p>
        <div className="flex items-center flex-col md:flex-row justify evenly justify-around">
          <SearchForm getItems={getItems} />
        </div>
      </div>
    </div>
  );
}
